module.exports = __webpack_public_path__ + "img/mensaje.731829fd.jpg";